import WexoModal from './modal';

export default WexoModal;
